import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SharedDataService } from '@esp-enrollment-form/shared-utils';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const sharedDataService = inject(SharedDataService);
  const token = sharedDataService.token();
  
  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(request);
};
